/* eslint-disable semi */
/* eslint-disable prettier/prettier */
import styled, { css } from "styled-components";

export const BasedButton = styled.button`
    outline-style: none !important;
    border-radius: 50px;
    box-shadow: none;
    border: 1px solid transparent;
    padding: 0.525em 2.5rem;
    line-height: 1.5;
    font-weight: 600;
    font-size: 1.25em;
    /* width: 13.75em; */

    ${({ size }) => {
        if (size === "lg") {
            return css`
                font-size: 1.25em;
                padding: 1.25em 2.5em;
            `;
        }

        if (size === "sm") {
            return css`
                font-size: 0.8125em;
                padding: 0.7125em 1.5em;
                font-weight: 500;
                letter-spacing: 0.0625em;
            `;
        }
    }}

    ${({ block }) => {
        if (block) {
            return css`
                width: 100%;
            `;
        }
    }}
`;

export const PrimaryButton = styled(BasedButton)`
    ${({ disabled }) => {
        if (disabled) {
            return css`
                color: var(--neutralcolor-medium);
                background: var(--neutralcolor-light);
                &:hover {
                    color: var(--neutralcolor-medium);
                }
            `;
        }
        return css`
            background: var(--managercolor-primary-medium);
            color: var(--neutralcolor-lightest);
            &:hover {
                background: var(--managercolor-primary-dark);
            }
        `;
    }}
`;
export const SecondaryButton = styled(BasedButton)`
    ${({ disabled }) => {
        if (disabled) {
            return css`
                border: 2px solid var(--neutralcolor-medium);
                color: var(--neutralcolor-medium);
                background: var(--neutralcolor-lightest);
            `;
        }
        return css`
            border: 1px solid var(--neutracolor-brand-darkest);
            color: var(--neutracolor-brand-darkest);
            background: var(--neutralcolor-lightest);
            &:hover {
                border: 1px solid var(--neutralcolor-lightest);
                color: var(--neutralcolor-lightest);
                background: var(--neutracolor-brand-darkest);
            }
        `;
    }}
`;
